import React from 'react'
import Box from '@mui/material/Box'
import FormLabel from '@mui/material/FormLabel'
import TooltipPopover from "@/components/shared/others/TooltipPopover"

type Props = {
  label: string
  tooltipText: string
}

const LabelPopover: React.FC<Props> = ({ label, tooltipText }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormLabel>{label}</FormLabel>
      <TooltipPopover>
        {tooltipText}
      </TooltipPopover>
    </Box>
  )
}

export default LabelPopover
